import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {state} from '@bitstillery/mithril'
import {Button, FieldText} from '@bitstillery/common/components'
import {and, email, required, validation} from '@bitstillery/common/lib/validation'
import {$t, api, notifier} from '@bitstillery/common/app'

import type {ForgotPasswordRequest} from '@bitstillery/common/api/fact2server'

export interface AuthForgotPasswordAttrs {
    /** When set (e.g. portal auth dialog), called after a successful request instead of clearing the route */
    on_complete?: () => void
}

export class AuthForgotPassword extends MithrilComponent<AuthForgotPasswordAttrs> {
    data = (() => {
        const form = {
            email_address: '',
        }
        return state({form}, 'auth-forgot-password-data')
    })()

    $v = {
        email_address: validation(this.data.form.$email_address, and([required(), email()])),
    }

    request_id = m.route.param('request_id')
    private on_complete: (() => void) | undefined

    override oninit(vnode: m.Vnode<AuthForgotPasswordAttrs>) {
        this.on_complete = vnode.attrs.on_complete
    }

    override onupdate(vnode: m.Vnode<AuthForgotPasswordAttrs>) {
        this.on_complete = vnode.attrs.on_complete
    }

    async submit() {
        if (process.env.MSI_PACKAGE === 'portal') {
            const data: ForgotPasswordRequest = {
                email_address: this.data.form.email_address,
            }
            await api.post('portal/user/forgot-password', data, true)
        } else {
            const data: {username: string} = {
                username: this.data.form.email_address,
            }
            await api.post('auth.forgot_password', data)
        }

        notifier.notify($t('forgot_password.confirmed'), 'info')
        if (this.on_complete) {
            this.on_complete()
        } else {
            void m.route.set('')
        }
    }

    view() {
        return (
            <div className='c-auth-forgot-password landing'>
                <div className='form'>
                    <h3>{$t('forgot_password.title')}</h3>
                    <p className='step-info'>{$t('forgot_password.description')}</p>

                    <FieldText
                        label={$t('forgot_password.email')}
                        model={this.data.form.$email_address}
                        help={$t('forgot_password.email_help')}
                        validation={this.$v.email_address}
                    />

                    <Button
                        disabled={Object.values(this.$v).filter((i) => i._invalid).length > 0}
                        onclick={this.submit.bind(this)}
                        text={$t('forgot_password.start_flow')}
                        type='success'
                    />
                </div>
            </div>
        )
    }
}
